import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-logout-dialog',
  templateUrl: './logout-dialog.component.html',
  styleUrls: ['./logout-dialog.component.scss'],
  standalone: false,
})
export class LogoutDialogComponent {

  heading:string = '';
  body:string = '';
  constructor(
    public dialogRef: MatDialogRef<LogoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
  ){
    this.heading = this.data.heading;
    this.body = this.data.body;
  }
  
  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  logOut() {
    localStorage.clear();
    this.authService.logout();
  }
}
